export const buildStripeReturnUrl = (
    transactionId: string,
    paymentMethod = "card"
): string => {
    const configuredUrl =
        process.env.REACT_APP_SUCCESS_LINK?.trim() || "/payment-verify";
    const origin =
        typeof window !== "undefined"
            ? window.location.origin
            : "https://sacafootball.com";
    const url = new URL(configuredUrl, origin);

    url.searchParams.set("transaction_id", transactionId);
    url.searchParams.set("payment_method", paymentMethod);

    return url.toString();
};
